import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { alpha, useTheme } from '@mui/material/styles';

interface NavItemProps {
  item: {
    title: string;
    href: string;
    icon: React.ComponentType<any>;
  };
  isActive: boolean;
}

const NavItem = ({ item, isActive }: NavItemProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const Icon = item.icon;

  const handleClick = () => {
    navigate(item.href);
  };

  return (
    <Box sx={{ mb: 1 }}>
      <Button
        onClick={handleClick}
        startIcon={<Icon />}
        fullWidth
        sx={{
          justifyContent: 'flex-start',
          textTransform: 'none',
          color: isActive ? theme.palette.primary.main : theme.palette.text.secondary,
          backgroundColor: isActive ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
          fontWeight: isActive ? 600 : 400,
          '&:hover': {
            backgroundColor: isActive
              ? alpha(theme.palette.primary.main, 0.15)
              : alpha(theme.palette.text.primary, 0.05),
          },
          borderLeft: isActive
            ? `3px solid ${theme.palette.primary.main}`
            : '3px solid transparent',
          paddingLeft: isActive ? '13px' : '16px',
        }}
      >
        {item.title}
      </Button>
    </Box>
  );
};

export default NavItem;
